<script>
  import { onMount } from "svelte";
  import { rawCalculatorData, rawCopy } from "../stores/rawData.js";

  import Styles from "./Styles.svelte";
  import Head from "./Head.svelte";
  import Wrapper from "./Wrapper.svelte";
  import Container from "./Container.svelte";
  import Controls from "./Controls.svelte";
  import Outputs from "./Helpers/Outputs.svelte";
  import Inputs from "./Helpers/Inputs.svelte";
  import Flag from "./Helpers/Flag.svelte";
  import Tile from "./Helpers/Tile.svelte";

  import getUrlStatus from "../utils/getUrlStatus.js";
  import getData from "../utils/getData.js";

  import {
    currentPlanId,
    dropdownData,
    generalPlanData,
    currentScenario,
    replacementRate,
    estimatedPension,
    inflationAdjustedPension,
    noCalcFlag,
    hybridFlag,
    ssaFlag,
    vestingFlag,
    maxSalaryFlag,
    maxReplacementFlag,
    reportCopy,
    getCopyId,
  } from "../stores/currentSelections.js";
  import { containerBBox, containerW, windowW } from "../stores/dimensions";
  import Icon from "./Helpers/Icon.svelte";

  let mounted = false;
  let clientWidth;

  onMount(async () => {
    const status = getUrlStatus();

    const parsedCalculatorData = await getData(status, "planData");
    const parsedCopy = await getData(status, "copy");

    $rawCalculatorData = parsedCalculatorData;
    $rawCopy = parsedCopy;

    console.log("parsed");

    mounted = true;
  });

  $: title = getCopyId($reportCopy, "calculator-title");
  $: subTitle = getCopyId($reportCopy, "calculator-sub-title");

  let containerH = 0,
    tileH = 0;

  $: inputsClass =
    $currentPlanId && $currentScenario && !$noCalcFlag
      ? ""
      : "opacity-20 pointer-events-none";
</script>

<Head />
<Styles />

{#if !mounted || !$dropdownData || !$reportCopy}
  <div class="loader-wrapper">
    <div class="loader-inner">
      <img
        alt="Loading..."
        src="/df_assets/img/icons/spinner-Light.svg"
        height="100"
        width="100px"
        class="loader-spinner"
      />
    </div>
  </div>
{:else}
  <Container>
    <div
      style="height: {containerH +
        tileH +
        (tileH > 0 && !$noCalcFlag ? 32 : 0)}px;"
      class="transition-all"
      bind:clientWidth
    >
      <div bind:clientHeight={containerH} class="p-4 md:p-8">
        <div
          class="flex {clientWidth > 475
            ? 'flex-row space-x-4'
            : 'flex-col'} justify-between border-b-1 border-neutral-3"
        >
          <div class={clientWidth > 475 ? "order-1" : "order-2"}>
            <h3 class="mb-2">
              {@html title}
            </h3>
            <p class="pb-2">
              {@html subTitle}
            </p>
          </div>
          <a
            href="https://equable.org/"
            class="flex-shrink-0  {clientWidth > 475
              ? 'order-2'
              : 'order-1'} mb-4"
            target="_blank"
          >
            <Icon
              src="https://equable.org/wp-content/themes/wordpress-template/assets/images/nav-logo.svg"
              size="150"
            />
          </a>
        </div>
        <Controls />
      </div>
      <div bind:clientHeight={tileH}>
        {#if $noCalcFlag}
          <div class="pb-4 md:pb-8">
            <Flag
              copy={$generalPlanData["notes_text"]}
              bgColor="light-red"
              textColor="red"
              rounded={false}
            />
          </div>
        {/if}
        <div class="px-4 md:px-8 {inputsClass}">
          <Tile>
            <Inputs />
            {#if $vestingFlag}
              <Flag
                copy={$generalPlanData["vesting_note_text"]}
                bgColor="light-red"
                textColor="red"
              />
            {:else if $replacementRate && $estimatedPension && $inflationAdjustedPension}
              <Outputs />
              {#if $maxReplacementFlag}
                <Flag
                  key="max-replacement"
                  bgColor="light-red"
                  textColor="red"
                />
              {/if}
            {/if}
            {#if $hybridFlag}
              <Flag
                copy={$generalPlanData["notes_text"]}
                bgColor="light-red"
                textColor="red"
                rounded={true}
              />
            {/if}
            <!-- <Flag key="ssa-yes" /> -->
          </Tile>
        </div>
      </div>
    </div>
  </Container>
{/if}

<style global lang="postcss">
  .loader-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .loader-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .loader-spinner {
    -webkit-animation: spin 2s infinite linear;
    animation: spin 2s infinite linear;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>
